// Initialization helpers for SubmissionHome
import { ProductTranslator, AllowableFileTypesText, AllowableFileTypes, PlanLockButtonTitle, PlanLockButtonMainText, PlanLockButtonTitleUndo, PlanLockButtonMainTextUndo, AuditLockButtonUndoTitle, AuditLockButtonUndoMainText, AuditLockNoActionText, AuditLockButtonMainText, AuditLockButtonTitle, MarkFinalButtonMainText, MarkFinalButtonTitle, MarkFinalButtonMainTextUndo, MarkFinalButtonTitleUndo, MarkFinalNoActionText, AttestationButtonTitleUndo, AttestationButtonMainTextUndo, AttestationNoActionText, ClearMeasureButtonTitle, ClearMeasureButtonMainText, AttestationButtonTitle, AttestationButtonMainText } from '../../../../Utilities/ProductTypeTranslation';
import * as AuthorizationPolicies from '../../../../Configuration/AuthorizationPolicies';
import { HOS_ENABLE_INTERIM_SUBMISSION, VIEW_ART, UPLOAD_DOCUMENT_HEDIS, UPLOAD_DOCUMENT_NONHEDIS, PLAN_LOCK, UNLOCK_PLAN_LOCK, AUDIT_LOCK, UNLOCK_AUDIT_LOCK, MARK_FINAL_HEDIS, MARK_FINAL_CAHPS, MARK_FINAL_HOS, SUBMISSION_GENERIC_ADMIN, ASSIGN_AUDIT_DESIGNATION, SIGN_ATTESTATION_HEDIS, SIGN_ATTESTATION_HOS, DOWNLOAD_RESULTS_HEDIS, DOWNLOAD_RESULTS_CAHPS, DOWNLOAD_RESULTS_HOS, MANAGE_HEDIS_USER, MANAGE_PUBLIC_REPORTING, VIEW_DOWNLOAD_ERRORS_HEDIS, VIEW_DOWNLOAD_ERRORS_NONHEDIS, VIEW_RESULTS_REPORTS_HEDIS } from '../../../Shared/Constants';
import AdministrationService from '../../../Services/AdministrationService';
import { firstValueFrom } from 'rxjs';

export function getInitialSubmissionHomeState(props) {
    const component = props.match.params.component;
    return {
        submissionData: {
            productLine: '',
            reportingProduct: '',
            reportingUnitId: '',
            specialArea: '',
            specialProject: '',
            subId: Number(props.match.params.subId),
            orgId: -1,
            orgName: '',
            cmsContract: '',
            vendorId: -1,
            activeStepNumber: -1,
            component: '',
            isFileProcessed: false,
            isFileUploaded: false,
            didValidationError: false,
            didValidationWarning: false,
            isFileUploadAllowed: false,
            fileUploadNotAllowedReason: '',
            submissionDownloads: [],
            isPublicReported: null,
            somc: null,
            attestationModifiedDate: null,
            isAccredited: false,
            hasSubmissionAccess: false,
            isAuditRequired: false,
            validationStatus: '',
            isFinal: null,
            isAttested: null,
            requiredFileName: null,
            isCahpsOnlySubmission: false,
            hedisSubInMarkFinalOrEarlier: false,
            submissionIntention: '',
        },
        currentSubId: props.match.params.subId,
        isMainTabLoading: true,
        isAuditorTabLoading: true,
        isGenericActionHappening: false,
        uploadSection: {
            uploadFiles: [],
            dropzoneStatusStyle: '',
            uploadCompletionPercent: 0,
            fileProcessingComplete: false,
            uploadValidationMessages: [],
            uploadSuccessful: false
        },
        validation: {
            submissionId: -1,
            urlString: '',
            headerUrlString: '',
            detailUrlString: '',
            validationText: '',
            validationErrors: []
        },
        currentTabVal: 0,
        component: component,
        auths: {
            isGlobalAdmin: false,
            isOrgAdmin: false,
            isOrgSigner: false,
            isVendorSigner: false,
            isOrgUser: false,
            isAuditor: false,
            isViewer: false,
            isVendorAdmin: false,
            isVenderUser: false,
            isSubmissionUser: false,
            user: props.user,
        },
        users: [],
        textLookup: {
            uploadFileText: ProductTranslator.getProductTypeName(component, new AllowableFileTypesText()),
            uploadFileType: ProductTranslator.getProductTypeName(component, new AllowableFileTypes()),
        },
        errorMsg: '',
        allAccounts: [],
        selectedAccount: '',
        selectedAccountLevel: { label: 'Submission Level', value: 'submission' },
        dialogStatus: {
            planLockOpen: false,
            planLockTitle: ProductTranslator.getProductTypeName(component, new PlanLockButtonTitle()),
            planLockText: ProductTranslator.getProductTypeName(component, new PlanLockButtonMainText()),
            planLockUndoOpen: false,
            planLockUndoTitle: ProductTranslator.getProductTypeName(component, new PlanLockButtonTitleUndo()),
            planLockUndoText: ProductTranslator.getProductTypeName(component, new PlanLockButtonMainTextUndo()),
            auditLockOpen: false,
            auditLockUndoTitle: ProductTranslator.getProductTypeName(component, new AuditLockButtonUndoTitle()),
            auditLockUndoText: ProductTranslator.getProductTypeName(component, new AuditLockButtonUndoMainText()),
            auditLockNoActionText: ProductTranslator.getProductTypeName(component, new AuditLockNoActionText()),
            auditLockUndoOpen: false,
            markFinalOpen: false,
            markFinalUndoOpen: false,
            auditLockText: ProductTranslator.getProductTypeName(component, new AuditLockButtonMainText()),
            auditLockTitle: ProductTranslator.getProductTypeName(component, new AuditLockButtonTitle()),
            markFinalText: ProductTranslator.getProductTypeName(component, new MarkFinalButtonMainText()),
            markFinalTitle: ProductTranslator.getProductTypeName(component, new MarkFinalButtonTitle()),
            markFinalUndoText: ProductTranslator.getProductTypeName(component, new MarkFinalButtonMainTextUndo()),
            markFinalUndoTitle: ProductTranslator.getProductTypeName(component, new MarkFinalButtonTitleUndo()),
            markFinalNoActionText: ProductTranslator.getProductTypeName(component, new MarkFinalNoActionText()),
            attestationUndoOpen: false,
            attestationUndoTitle: ProductTranslator.getProductTypeName(component, new AttestationButtonTitleUndo()),
            attestationUndoText: ProductTranslator.getProductTypeName(component, new AttestationButtonMainTextUndo()),
            attestationNoActionText: ProductTranslator.getProductTypeName(component, new AttestationNoActionText()),
            hosAttestationUndoOpen: false,
            clearMeasuresOpen: false,
            clearMeasuresTitle: ProductTranslator.getProductTypeName(component, new ClearMeasureButtonTitle()),
            clearMeasuresText: ProductTranslator.getProductTypeName(component, new ClearMeasureButtonMainText())
        },
        attestation: {
            attestationStarted: false,
            attestationSigned: false,
            attestationTitle: ProductTranslator.getProductTypeName(component, new AttestationButtonTitle()),
            attestationText: ProductTranslator.getProductTypeName(component, new AttestationButtonMainText()),
        },
        isHistoryTabLoading: true,
        isAllDownloadsTabLoading: true,
        allDownloads: [],
        history: [],
        isSubmissionActivitiesLoading: true,
        isDetailedSubmissionDetailLoading: true,
        submissionActivities: [],
        detailedSubmissionMeta: [],
        isFlagUpdateSuccessful: false,
        isAdminUpdatingAttestFlags: false,
        isSysAdmin: AuthorizationPolicies.IsGlobalAdmin(props.user),
        isOrgAdmin: false,
        userAction: {
            canViewArt: false,
            canUploadHedis: false,
            canUploadNonHedis: false,
            canPlanLock: false,
            canPlanUnlock: false,
            canAuditLock: false,
            canAuditUnlock: false,
            canMarkFinalHedis: false,
            canMarkFinalCahps: false,
            canMarkFinalHos: false,
            canSubmissionGenericAdmin: false,
            canAssignAuditDesignation: false,
            canSignAttestationHedis: false,
            canSignAttestationHos: false,
            canDownloadResultHedis: false,
            canDownloadResultCahps: false,
            canDownloadResultHos: false,
            canManageHedisUser: false,
            canManagePublicReporting: false,
            canViewDownloadErrorsHedis: false,
            canViewDownloadErrorsNonHedis: false,
            canViewResultReportsHedis: false
        },
        showAllDownloads: true,
        redirect: false,
        validationResult: {},
        validationDialogOpen: false,
        currentValidationItem: null,
        isVendorMeasureGuidsLoading: false,
        vendorMeasureGuids: [],
        enableHosInterimDataSubmission: false
    };
}

export async function initializeComponentHome(self) {
    // Add user validation
    if (!self.props.user || !self.props.user.access_token) {
        console.error('User not properly initialized');
        setRedirectState(self);
        return;
    }
    await self.RefreshModel(self.state.currentTabVal);
    //get all user actions and update the state
    var userActions = await self.GetAllAuthorizedUserActions();
    if (userActions != null) {
        SetUserActions(self, userActions);
    }
    //get hos interim data submission config value
    const retval = await firstValueFrom(
        AdministrationService.GetConfigKey$(self.props.user, HOS_ENABLE_INTERIM_SUBMISSION)
    );
    if (!retval) {
        setRedirectState(self);
    } else {
        self.setState({ enableHosInterimDataSubmission: retval.toLowerCase() === 'true' });
    }
}

export function SetUserActions(self, userActions) {
    self.setState({
        userAction: {
            canViewArt: userActions[VIEW_ART],
            canUploadHedis: userActions[UPLOAD_DOCUMENT_HEDIS],
            canUploadNonHedis: userActions[UPLOAD_DOCUMENT_NONHEDIS],
            canPlanLock: userActions[PLAN_LOCK],
            canPlanUnlock: userActions[UNLOCK_PLAN_LOCK],
            canAuditLock: userActions[AUDIT_LOCK],
            canAuditUnlock: userActions[UNLOCK_AUDIT_LOCK],
            canMarkFinalHedis: userActions[MARK_FINAL_HEDIS],
            canMarkFinalCahps: userActions[MARK_FINAL_CAHPS],
            canMarkFinalHos: userActions[MARK_FINAL_HOS],
            canSubmissionGenericAdmin: userActions[SUBMISSION_GENERIC_ADMIN],
            canAssignAuditDesignation: userActions[ASSIGN_AUDIT_DESIGNATION],
            canSignAttestationHedis: userActions[SIGN_ATTESTATION_HEDIS],
            canSignAttestationHos: userActions[SIGN_ATTESTATION_HOS],
            canDownloadResultHedis: userActions[DOWNLOAD_RESULTS_HEDIS],
            canDownloadResultCahps: userActions[DOWNLOAD_RESULTS_CAHPS],
            canDownloadResultHos: userActions[DOWNLOAD_RESULTS_HOS],
            canManageHedisUser: userActions[MANAGE_HEDIS_USER],
            canManagePublicReporting: userActions[MANAGE_PUBLIC_REPORTING],
            canViewDownloadErrorsHedis: userActions[VIEW_DOWNLOAD_ERRORS_HEDIS],
            canViewDownloadErrorsNonHedis: userActions[VIEW_DOWNLOAD_ERRORS_NONHEDIS],
            canViewResultReportsHedis: userActions[VIEW_RESULTS_REPORTS_HEDIS]
        }
    });
}

export function setRedirectState(self) {
    self.setState({ redirect: true });
}
